// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","active":"active__3dCN7"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 8